module.exports = __webpack_public_path__ + "img/ad4.c9a4e25a.png";